import { Stack, styled as styledMUI } from '@mui/material';
import { partnerAssets } from 'partners/partnersAssets';
import { TProps_InstaSpinner } from 'typings';

const Spinner = styledMUI('div')(({ theme }) => ({
  '@keyframes interlaced': {
    '100%': {
      transform: 'rotate(1turn)'
    }
  },
  width: '100px',
  aspectRatio: 1,
  display: 'grid',
  color: theme.palette.primary.main,
  border: `4px solid transparent`,
  borderRadius: '50%',
  borderRightColor: theme.palette.primary.main,
  animation: 'interlaced 1s infinite linear',

  '&::before, &::after': {
    content: '""',
    gridArea: '1/1',
    margin: '8px',
    border: 'inherit',
    borderRadius: '50%',
    animation: 'interlaced 2s infinite'
  },
  '&::after': {
    margin: '2px',
    animationDuration: '3s'
  }
}));

function InstaSpinner({ withWrapper = false }: TProps_InstaSpinner) {
  return (
    <Stack
      display="-webkit-box !important"
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        height: withWrapper ? '60vh' : '100%',
        justifyContent: withWrapper ? 'center' : 'unset'
      }}
    >
      <Spinner />
      <img
        src={partnerAssets.logoContrastIcon}
        alt="loader_icon"
        width="40px"
        height="40px"
        style={{
          marginLeft: -70.25
        }}
      />
    </Stack>
  );
}
export default InstaSpinner;
